module.exports = __webpack_public_path__ + "media/bgm.12724d24.webm";